// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__V9FVN","insightsList":"newBusinessInsightsMenu_insightsList__i09VJ","active":"newBusinessInsightsMenu_active__2Mk5j"};